export const getQueuesAPI = (url, body, callback, token) => {
    fetch("https://api.queuesapp.com/" + url, {
      headers: { "Content-Type": "application/json", token: token },
      method: "POST",
      body: JSON.stringify(body),
    })
      .then((response) => {
        if (!response.ok && url !== "send-dashboard-password-reset-code") {
          //throw new Error(`HTTP error! status: ${response.status}`);
          throw response;
        }
        return response.json();
      })
      .then((data) => callback(data))
      .catch((error) => {
        // Do not have this error line active in PROD! Shows sensitive information
        // console.error("There was a problem with the fetch operation:", error);
        callback(null, error);
      });
  };